import MaterialButton from "@material-ui/core/Button";
import Menu from "@material-ui/core/Menu";
import React from "react";
import styled from "styled-components";

interface IProps {
  title: string;
  icon: string;
  handleClick: (event: React.MouseEvent<HTMLButtonElement>) => void;
  handleClose: () => void;
  anchorEl: null | HTMLElement;
}

const DropDown: React.FC<IProps> = ({
  title,
  icon,
  handleClick,
  handleClose,
  anchorEl,
  children
}) => {
  return (
    <React.Fragment>
      <MaterialButton
        aria-controls="simple-menu"
        aria-haspopup="true"
        onClick={handleClick}
      >
        <Icon className={icon} />
        <span>{title}</span>
      </MaterialButton>
      <Menu
        id="simple-menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        {children}
      </Menu>
    </React.Fragment>
  );
}

const Icon = styled.i`
  font-size: 15px;
  margin-right: 5px;
`;

export default DropDown;